// Clinic photos hosted on customer-assets (whitelisted by /api/img proxy).
// Verified via AI content analysis + user-provided context.

export const CLINIC_PHOTOS = {
  // Building exterior — full facade with SHANTANU NETRALAYA signage and doctor plaques
  exteriorDay:
    "https://customer-assets.emergentagent.com/job_shantanu-netralaya/artifacts/55a2lhi6_887d09f6-aac0-453c-bc07-62fb61dcc9cc.jpg",
  // Building exterior — alternate angle (bright sky)
  exteriorFront:
    "https://customer-assets.emergentagent.com/job_shantanu-netralaya/artifacts/0zhabhrx_FullSizeRender%202.webp",
  // Corridor leading to Operation Theatre with Sn logo doors + Vivinex IOL posters
  corridorToOT:
    "https://customer-assets.emergentagent.com/job_shantanu-netralaya/artifacts/qb6wrrwm_IMG_1864.webp",
  // Consultation / examination room with slit-lamp, autorefractor, award cabinet
  consultationRoom:
    "https://customer-assets.emergentagent.com/job_shantanu-netralaya/artifacts/4rohy1sf_IMG_4525.webp",
  // Operating theatre — full room view with operating table + Zeiss microscope
  operatingTheatre:
    "https://customer-assets.emergentagent.com/job_shantanu-netralaya/artifacts/endnogv7_20250529_43212PMByGPSMapCamera.webp",
  // Reception area with waiting patients (busy day)
  receptionBusy:
    "https://customer-assets.emergentagent.com/job_shantanu-netralaya/artifacts/3arel801_98038E73165D_20250908174018913_cam0.webp",
  // 3nethra Classic fundus camera diagnostic setup (medical retina imaging)
  fundusCamera:
    "https://customer-assets.emergentagent.com/job_shantanu-netralaya/artifacts/evj0ubnz_IMG_1862%202.webp",
  // Dr. Shantanu at Carl Zeiss microscope (close-up portrait)
  drAtMicroscope:
    "https://customer-assets.emergentagent.com/job_shantanu-netralaya/artifacts/7rkmf34q_IMG_5189.webp",
  // Wider OT view — Dr. Shantanu operating with instruments visible in background
  otWide:
    "https://customer-assets.emergentagent.com/job_shantanu-netralaya/artifacts/30fr6xvy_IMG_5184.webp",
  // Waiting area with Tecnis Eyhance & Vivinex IOL banners
  waitingArea:
    "https://customer-assets.emergentagent.com/job_shantanu-netralaya/artifacts/0dbirh7e_IMG_4996.webp",
  // Day-care recovery ward with beds
  recoveryRoom:
    "https://customer-assets.emergentagent.com/job_shantanu-netralaya/artifacts/g4zw2vhy_IMG_4994.webp",
  // Reception desk with LED-lit curved counter
  reception:
    "https://customer-assets.emergentagent.com/job_shantanu-netralaya/artifacts/4khj7cak_IMG_4992.webp",
  // Insurance / cashless mediclaim empanelment poster (all TPAs)
  insurancePoster:
    "https://customer-assets.emergentagent.com/job_shantanu-netralaya/artifacts/icqt3z7z_unnamed.png",
  // Ayushman Bharat (PM-JAY) empanelment poster
  ayushmanBharat:
    "https://customer-assets.emergentagent.com/job_shantanu-netralaya/artifacts/rluqt9fz_0C4A9276-5F08-4437-A2B2-D1A41892CCB8.PNG",
};

export const CLINIC_GALLERY = [
  { src: CLINIC_PHOTOS.exteriorDay, caption: "Shantanu Netralaya on a bright Kashi morning", tall: true },
  { src: CLINIC_PHOTOS.operatingTheatre, caption: "Sterile operating theatre — Team Shantanu Netralaya" },
  { src: CLINIC_PHOTOS.otWide, caption: "Micro-incision cataract surgery in progress" },
  { src: CLINIC_PHOTOS.corridorToOT, caption: "Corridor to the operation theatre" },
  { src: CLINIC_PHOTOS.consultationRoom, caption: "Consultation & diagnostic room" },
  { src: CLINIC_PHOTOS.fundusCamera, caption: "3nethra fundus camera for retina imaging" },
  { src: CLINIC_PHOTOS.waitingArea, caption: "Patient waiting area" },
  { src: CLINIC_PHOTOS.reception, caption: "Reception & TPA / insurance help desk" },
  { src: CLINIC_PHOTOS.recoveryRoom, caption: "Day-care recovery ward" },
];
